import { EngagementMeeting } from '../models/get-engagement-conference';
import { EngagementMeetingProposalContract } from '../models/engagement-meeting-proposal-contract';
import { MeetingProposalStatus } from '../models/enums/meeting-proposal-status.enum';
import { EngagementMeetingStatus } from '../models/enums/meeting-status.enum';

// [#1304] A meeting held or under way: it is never the Buyer's current meeting, so it never stops a further request
// (BuyerMeetings.HasStarted in the API).
export const hasMeetingStarted = (meetings: EngagementMeeting[], meetingId?: string): boolean =>
    meetings.some(
        (meeting) =>
            meeting.engagementMeetingId === meetingId &&
            (meeting.status === EngagementMeetingStatus.InProgress ||
                meeting.status === EngagementMeetingStatus.Completed)
    );

// [#1304] A Buyer pays for one meeting (Roman, 16-Oct): once they have had one - held or under way - a further meeting is
// free and never replaces it. Mirrors BuyerMeetings in the API, so a screen does not ask for a card the server won't
// charge. Without a buyer id every request counts - a Buyer's screens hold only their own.
export const hasBuyerHadAMeeting = (
    proposals: EngagementMeetingProposalContract[],
    meetings: EngagementMeeting[],
    buyerId?: number
): boolean =>
    proposals.some(
        (proposal) =>
            (buyerId == null || proposal.buyerId === buyerId) &&
            proposal.status === MeetingProposalStatus.Confirmed &&
            !proposal.isCancelled &&
            hasMeetingStarted(meetings, proposal.meetingId)
    );
